import React, { useEffect, useState } from "react";
import VipAdvertItem from "../../main/items/vip_advert_item";
import { getUserFavorites } from "../../../api/favoritecall";

import image1 from '../../images/vip1.png';
import app_icon_mini from '../../images/app_icon_mini.svg';

import like_icon from '../../../assets/icons/heart.svg';

import Loading from "../../../common/components/Loading";
import Icon from "../../../common/components/Icon";
import { t } from "i18next";

function Favorites({ setActiveTab }) {
    const [favorites, setFavorites] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchFavorites = async () => {
        try {
            const data = await getUserFavorites();
            setFavorites(data.items || []);
        } catch (err) {
            setError(err.message);
            console.error("Error fetching user favorites:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFavorites();
    }, []);

    const handleFavoriteRemove = (announcementId) => {
        setFavorites(prevFavorites => 
            prevFavorites.filter(fav => fav.id !== announcementId)
        );
    };

    if (isLoading) {
        return <Loading />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="w-full">
            <Icon src="backicon" onClick={setActiveTab} className="block md:hidden fixed left-5 top-[23px] cursor-pointer z-[102]" />

            {/* fab_content → mt-5 */}
            <div className="mt-5">

                <div className="grid grid-cols-2 md:grid-cols-3 gap-5 w-full auto-rows-fr px-5 md:px-0">
                    {favorites.length > 0 ? (
                        favorites.map((favorite, index) => (
                            <VipAdvertItem
                                key={favorite.id || index}
                                id={favorite.id}
                                imagePath={favorite.main_image_url || image1}
                                name={favorite.title}
                                price={favorite.price}
                                price_type={favorite.price_type}
                                is_negotiable={favorite.is_negotiable}
                                location={favorite.user_location_id}
                                date={favorite.created_at}
                                barter={favorite.barter}
                                is_favorite={true}
                                onFavoriteToggle={handleFavoriteRemove}
                            />
                        ))
                    ) : null}
                </div>

                {favorites.length === 0 && (
                    <div className="flex flex-col items-center justify-center text-center mt-10 gap-3">
                        <img className="w-16 h-16" src={app_icon_mini} alt="logo" />
                        <h2 className="text-xl font-bold">
                            {t('noFavoritesTitle')}
                        </h2>
                        <p className="text-gray-500">
                            {t('noFavoritesDescription')}
                        </p>
                        <img src={like_icon} className="w-6 h-6" alt="heart" />
                    </div>
                )}

            </div>
        </div>
    );
}

export default Favorites;